(function () {
  function init(root) {
    if (!root) root = document;

    var fills = root.querySelectorAll('.thc-specs__bar-fill[data-target-width]');
    fills.forEach(function (el) {
      if (el.dataset.thcSpecsInit === '1') return;
      el.dataset.thcSpecsInit = '1';

      var target = parseFloat(el.getAttribute('data-target-width') || '0');
      el.style.width = '0%';

      // 2x rAF = sicherer Paint vom 0%-Startzustand, dann Animation
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.style.width = target + '%';
        });
      });
    });
  }

  // Initial auf normalen Seiten
  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  // Theme-Editor / Section reloads
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Quickview/Modal/AJAX: beobachtet neu eingefügtes HTML
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;

        if (node.matches && node.matches('.thc-specs')) {
          init(node);
        } else if (node.querySelector) {
          var has = node.querySelector('.thc-specs');
          if (has) init(node);
        }
      });
    });
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  // optional manuell aufrufbar
  window.initThcSpecs = init;
})();